import { FirestoreDataConverter, DocumentData, QueryDocumentSnapshot, SnapshotOptions } from "firebase/firestore";

export const MESSAGE_PATH = "chat_messages";

export type MessageType = {
  id: string;
  influencerTicketId: string;
  ticketId: string;
  senderId: string;
  senderType: "influencer" | "store" | "admin";
  message: {
    type: "text" | "imageUrl" | "link" | "alert" | "file";
    data: string;
    label?: string | null;
  };
  createTime: number;
  updateTime: number;
  deletedAt?: number | null;
};

export const messageConverter: FirestoreDataConverter<MessageType> = {
  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): MessageType {
    const data = snapshot.data(options);
    return {
      id: snapshot.id,
      influencerTicketId: data.influencerTicketId,
      ticketId: data.ticketId,
      senderId: data.senderId,
      senderType: data.senderType,
      message: {
        type: data.message.type,
        data: data.message.data,
        label: data.message.label,
      },
      createTime: data.createTime,
      updateTime: data.updateTime,
      deletedAt: data.deletedAt ? Math.round(data.deletedAt) : null,
    };
  },
  toFirestore(message: MessageType): DocumentData {
    return {
      id: message.id,
      influencerTicketId: message.influencerTicketId,
      ticketId: message.ticketId,
      senderId: message.senderId,
      senderType: message.senderType,
      message: {
        type: message.message.type,
        data: message.message.data,
        label: message.message.label || null,
      },
      createTime: message.createTime,
      updateTime: message.updateTime,
      deletedAt: message.deletedAt ? Math.round(message.deletedAt) : null,
    };
  },
};
